export const croatia = [
        {
            category: 'Voće',
            text: 'Cijene voća na tržnicama u Hrvatskoj',
            config: 'croatiaFruit',
            subcategories:[
               {
                name: 'Jabuka',
                text: 'Cijene jabuke na tržnicama u Hrvatskoj',
                category: 1,
               },
               {
                   name: 'Kruške',
                   text: 'Cijene kruške na tržnicama u Hrvatskoj',
                   category: 1,
                   
                  },{
                   name: 'Grožđe',
                   text: 'Cijene grožđa na tržnicama u Hrvatskoj',
                   category: 1,
                  },{
                   name: 'Breskva',
                   text: 'Cijene bresaka na tržnicama u Hrvatskoj',
                   category: 1,
                  },{
                   name: 'Nektarina',
                   text: 'Cijene nektarine na tržnicama u Hrvatskoj',
                   category: 1,
                  },{
                   name: 'Mandarina',
                   text: 'Cijene mandarine na tržnicama u Hrvatskoj',
                   category: 1,
                  },{
                   name: 'Naranča',
                   text: 'Cijene naranče na tržnicama u Hrvatskoj',
                   category: 1,
                  },{
                   name: 'Limin',
                   text: 'Cijene limuna na tržnicama u Hrvatskoj',
                   category: 1,
                  },{
                   name: 'Banana',
                   text: 'Cijene banane na tržnicama u Hrvatskoj',
                   category: 1,
                  },{
                   name: 'Šljiva',
                   text: 'Cijene šljive na tržnicama u Hrvatskoj',
                   category: 1,
                  },{
                    name: 'Grejp',
                    text: 'Cijene grejpa na tržnicama u Hrvatskoj',
                    category: 1,
                   },
                   {
                    name: 'Kivi',
                    text: 'Cijene kivija na tržnicama u Hrvatskoj',
                    category: 1,
                   },
                   {
                    name: 'Dinja',
                    text: 'Cijene dinja na tržnicama u Hrvatskoj',
                    category: 1,
                   }
            ]
           },
        {
         category: 'Povrce',
         text: 'Cijene povrca na tržnicama u Hrvatskoj',
        config: 'croatiaVege',
         subcategories:[
            {
             name: 'Rajčica',
             text: 'Cijene rajčice na tržnicama u Hrvatskoj',
             category: 2,
            },
            {
                name: 'Peršin',
                text: 'Cijene peršina na tržnicama u Hrvatskoj',
                category: 2,
               },
            {
                name: 'Paprika',
                text: 'Cijene paprike na tržnicama u Hrvatskoj',
                category: 2,
                
               },{
                name: 'Patlidžan',
                text: 'Cijene patlidžana na tržnicama u Hrvatskoj',
                category: 2,
               },{
                name: 'Krastavc',
                text: 'Cijene krastavca na tržnicama u Hrvatskoj',
                category: 2,
               },{
                name: 'Luk crni',
                text: 'Cijene crnog luka na tržnicama u Hrvatskoj',
                category: 2,
               },{
                name: 'Češnjak (luk beli)',
                text: 'Cijene češnjak na tržnicama u Hrvatskoj',
                category: 2,
               },{
                name: 'Kupus',
                text: 'Cijene kupusa na tržnicama u Hrvatskoj',
                category: 2,
               },{
                name: 'Mrkva (šargarepa)',
                text: 'Cijene mrkve na tržnicama u Hrvatskoj',
                category: 2,
               },{
                name: 'Mahune (boranije)',
                text: 'Cijene mahune na tržnicama u Hrvatskoj',
                category: 2,
               },{
                name: 'Grah',
                text: 'Cijene graha na tržnicama u Hrvatskoj',
                category: 2,
               },{
                name: 'Krumpir',
                text: 'Cijene krumpira na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'Šampinjoni',
                text: 'Cijene šampinjona na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'Špinat (spanać)',
                text: 'Cijene špinata na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'Zelena salata',
                text: 'Cijene zelene salate na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'Krastavci',
                text: 'Cijene krastavca na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'Kelj',
                text: 'Cijene kelja na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'Cvjetača',
                text: 'Cijene cvjetače na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'Crveni radić',
                text: 'Cijene crvenog radića na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'Blitva',
                text: 'Cijene blitve na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'endivija',
                text: 'Cijene endivije na tržnicama u Hrvatskoj',
                category: 2,
               },
               {
                name: 'RRotkvica',
                text: 'Cijene rotkvice na tržnicama u Hrvatskoj',
                category: 2,
               },
         ]
        }
    ]
